module.exports = __webpack_public_path__ + "static/media/PA.02e69c6d.png";